import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Button,
  Stack,
  Typography,
} from '@mui/material'

export default function ArchiveClassroomsTable({
  sections = [],
  selectedClassrooms = [],
  onSelectClassroom,
  onArchiveToggle,
  onDeleteClassroom,
}) {
  return (
    <TableContainer
      sx={{
        boxShadow: 'none',
        border: '1px solid #eee',
        borderRadius: '12px',
        boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
      }}
    >
      {sections.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow sx={{ background: '#FAFAFA' }}>
              <TableCell sx={{ p: '12px 24px' }}>Classroom Name</TableCell>
              <TableCell align="right" sx={{ p: '12px 24px' }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {sections?.map((row, i) => (
              <TableRow key={row.id} sx={{ ...(i % 2 === 1 && { background: '#FAFAFA' }) }}>
                <TableCell sx={{ p: '16px 24px', fontWeight: 500, color: '#101828' }}>{row.name}</TableCell>
                <TableCell align="right" sx={{ p: '16px 24px' }}>
                  <Stack direction="row" gap={1} justifyContent="flex-end">
                    <Button
                      color={row.archived ? 'secondary' : 'primary'}
                      size="small"
                      onClick={() => onArchiveToggle(row)}
                    >
                      {row.archived ? 'Unarchive' : 'Archive'}
                    </Button>
                    <Button
                      color="error"
                      size="small"
                      sx={{ textTransform: 'none', fontWeight: 500 }}
                      onClick={() => onDeleteClassroom(row)}
                    >
                      Delete
                    </Button>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Typography sx={{ p: '16px 24px' }} textAlign="center">
          No archived classrooms
        </Typography>
      )}
    </TableContainer>
  )
}
